export default __webpack_public_path__ + "static/media/flag_pop.4947b0a4.svg";